import { EnrollmentWithStudentTypes } from '@shared/common';

export enum enrollmentStatuses {
  'Upcoming' = 1,
  'Active' = 2,
  'Ended' = 3,
  'Suspended' = 4,
  'Canceled' = 5,
}

export const ENROLLMENT_STATUSES: Record<number, string> = {
  [enrollmentStatuses.Upcoming]: 'Upcoming',
  [enrollmentStatuses.Active]: 'Active',
  [enrollmentStatuses.Ended]: 'Ended',
  [enrollmentStatuses.Suspended]: 'Suspended',
  [enrollmentStatuses.Canceled]: 'Canceled',
};

export const enrollmentStatusColors: { [key: number]: string } = {
  [enrollmentStatuses.Upcoming]: 'text-customGold',
  [enrollmentStatuses.Active]: 'text-customLime',
  [enrollmentStatuses.Ended]: 'text-customRed',
  [enrollmentStatuses.Suspended]: 'text-customRed',
  [enrollmentStatuses.Canceled]: 'text-customRed',
};

export const getMentorSessionShare = (enrollment: EnrollmentWithStudentTypes) => {
  const total = enrollment.noOfMySessions ?? enrollment.noOfSessions;
  const completed = enrollment.noOfMyCompletedSessions ?? enrollment.noOfCompletedSessions;
  const scheduledOrInProgress =
    enrollment.noOfMyScheduledOrInProgressSessions ?? enrollment.noOfScheduledOrInProgressSessions;
  const isPrimaryMentor = enrollment.isPrimaryMentor ?? true;

  const pending = enrollment.noOfMyPendingSessions ?? total - completed - scheduledOrInProgress;

  return {
    total,
    completed,
    isPrimaryMentor,
    holdsSubset: total !== enrollment.noOfSessions,
    hasSessionsLeft: pending > 0,
  };
};
